import React from 'react'
import { getImageUrl } from './uspUtils'

const ExpandedUspModalT1 = ({ onClose, onPrev, onNext, modalList, dropdownSelection, capitalize, currentItemType, isSpanishEnterprise, currentIndex = 1, totalItems = 1 }) => {
  const itemType = currentItemType || dropdownSelection;
  const imageUrl = getImageUrl(modalList, itemType);

  const title = itemType === "EXT"
    ? (isSpanishEnterprise ? capitalize(modalList?.desc) : capitalize(modalList?.key))
    : modalList?.reasons?.[0] || capitalize(modalList?.key);

  const description = itemType === "EXT"
    ? modalList?.desc
    : modalList?.feature || modalList?.desc;

  return (
    <div className="w-full sm:max-w-[250px] md:max-w-[300px] lg:max-w-[400px] sm:max-h-[300px] md:max-h-[355px] lg:max-h-[600px] z-100">
      <div className="relative bg-[#1f2937] rounded-2xl overflow-hidden shadow-2xl border border-gray-700">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-10 w-8 h-8 bg-black/30 rounded-full flex items-center justify-center hover:bg-black/50 transition-all"
          aria-label="Close modal"
        >
          <img
              src="https://spyne-static.s3.us-east-1.amazonaws.com/console/crossWhite.svg"
              alt="Close"
              className="w-3 h-3"
            />
        </button>

        <div className="p-4 pb-2 text-left">
          <h3 className="text-white text-[14px] font-semibold leading-normal">
            {title}
          </h3>
        </div>

        <div className="relative sm:h-[180px] md:h-[250px] lg:h-[300px] bg-gray-800 mx-4 rounded-lg overflow-hidden">
          <img
            src={imageUrl}
            alt="Feature"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="p-4 pt-3 sm:max-h-[80px] md:max-h-[100px] lg:max-h-[150px] overflow-y-auto overflow-x-hidden">
          <p className="text-gray-300 text-sm text-left">
            {description}
          </p>
        </div>

        <div className="flex justify-between items-center px-4 pb-4">
          <button 
            onClick={onPrev}
            className="text-[#FFCD00] hover:text-[#FFCD00]/80 text-sm font-medium transition-colors"
          >
            Back
          </button>
          
          {/* <div className="text-gray-400 text-sm">
            {currentIndex}/{totalItems}
          </div> */}
          
          <button 
            onClick={onNext}
            className="text-[#FFCD00] hover:text-[#FFCD00]/80 text-sm font-medium transition-colors"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  )
}

export default ExpandedUspModalT1
